import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import '../css/about.scss'

const About = ({ data }) => {
  let { imageSharp } = data

  return (
    <section className="content">
      <Helmet title="About / Shi Shu" />
      <div id="about" className="fade">
        <article className="overview">
          <header>
            <h2 className="bold">Hello, I'm Shi Shu.</h2>
          </header>

        </article>
      </div>
    </section>
  )
}

export const pageQuery = graphql`
  query AboutQuery {
    imageSharp(id: { regex: "/about/" }) {
      sizes(maxWidth: 1000) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default About



// WEBPACK FOOTER //
// ./src/pages/about.js